import React from 'react';
import type { ProductPriceToDisplayProps } from 'common/components/product-card/types';
import { useProductPrice } from 'common/components/product-card/use-product-price';
import { PriceBlock } from 'fronton-react';

export const SponsoredProductPriceToDisplay: React.FC<ProductPriceToDisplayProps> = ({
  hasOldPrice,
  price,
  productPriceCategory,
}) => {
  const { mainPrice, units, discount, unitUnits, type } = useProductPrice({
    hasOldPrice,
    price,
    productPriceCategory,
  });

  return (
    <PriceBlock
      price={mainPrice}
      units={units}
      unitUnits={unitUnits}
      discount={discount}
      oldPrice={price.previous_price ?? undefined}
      type={type}
      size="s"
      direction="vertical"
      reversed
    />
  );
};
